import { useStaticQuery, graphql } from 'gatsby'

const useGallery = () => {
  const data = useStaticQuery(graphql`
    {
      allWpAlbum(filter: { title: { eq: "main" } }) {
        nodes {
          photoGallery {
            gallery {
              sourceUrl
              localFile {
                childImageSharp {
                  gatsbyImageData
                  thumbnail: gatsbyImageData(width: 140, height: 140)
                }
              }
            }
          }
        }
      }
    }
  `)
  return data.allWpAlbum.nodes[0].photoGallery.gallery.map(item => item)
}

export default useGallery
